import { render, staticRenderFns } from "./EditorField.vue?vue&type=template&id=d8d9486c&scoped=true&"
import script from "./EditorField.vue?vue&type=script&lang=js&"
export * from "./EditorField.vue?vue&type=script&lang=js&"
import style0 from "./EditorField.vue?vue&type=style&index=0&id=d8d9486c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d9486c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VInput})
